export default {
  pt: {
    pageTitle: "Endereço",
    mainTitle: "Endereço residencial",
    cepLabel: "CEP",
    streetLabel: "Logradouro",
    numberLabel: "Número",
    complementLabel: "Complemento",
    neighborhoodLabel: "Bairro",
    cityLabel: "Cidade",
    stateLabel: "Estado",
    continueButton: "Continuar",
    requiredField: "Campo obrigatório",
    requiredNumberField: "Campo obrigatório; caso não tenha, utilize s/n",
  },

  en: {
    pageTitle: "Address",
    mainTitle: "Residential address",
    cepLabel: "ZIP Code",
    streetLabel: "Street",
    numberLabel: "Number",
    complementLabel: "Complement",
    neighborhoodLabel: "Neighborhood",
    cityLabel: "City",
    stateLabel: "State",
    continueButton: "Continue",
    requiredField: "Required field",
    requiredNumberField: "Required field; if not available, use s/n",
  },
}; 